import {getFileMime} from './utils/get-file-mime';
import {extensionFromFilename} from './utils/extension-from-filename';
import {nanoid} from 'nanoid';
import {getActiveWorkspaceId} from '../workspace/active-workspace-id';
{/* start */}
/* import Tesseract, { createWorker } from 'tesseract.js';
import React,{useState, useEffect} from 'react';
import {apiClient} from '@common/http/query-client'; */

/* const pdfjsLib = await import('pdfjs-dist/build/pdf');
pdfjsLib.GlobalWorkerOptions.workerSrc =  `//unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.js`; */
{/* end */}


export class UploadedFile {
  id: string;
  fingerprint: string;
  name: string;
  relativePath = '';
  size: number;
  mime = '';
  extension = '';
  ocr_dedication= '';
  ocr_flag = false;
  native: File;
  lastModified: number;

  private cachedData?: string;
  get data(): Promise<string> {
    return new Promise(resolve => {
      if (this.cachedData) {
        resolve(this.cachedData);
      }
      const reader = new FileReader();

      reader.addEventListener('load', () => {
        this.cachedData = reader.result as string;
        resolve(this.cachedData);
      });

      if (this.extension === 'json') {
        reader.readAsText(this.native);
      } else {
        reader.readAsDataURL(this.native);
      }
    });
  }

  constructor(file: File, relativePath?: string | null) {
    this.id = nanoid();
    this.name = file.name;
    this.size = file.size;
    this.mime = getFileMime(file);
    this.lastModified = file.lastModified;
    this.extension = extensionFromFilename(file.name) || 'bin';
    this.native = file;
    relativePath = relativePath || file.webkitRelativePath || '';

    // remove leading slashes
    relativePath = relativePath.replace(/^\/+/g, '');

    // only include relative path if file is actually in a folder and not just /file.txt
    if (relativePath && relativePath.split('/').length > 1) {
      this.relativePath = relativePath;
    }

    //ocr code

    /* if( this.mime.includes('image')){

    } */

    /* if(this.mime == 'application/pdf'){
        getItems(URL.createObjectURL(file));
        async function getContent(file: any){
          const pdfJS = await import('pdfjs-dist/build/pdf' as any);
          pdfJS.GlobalWorkerOptions.workerSrc =  `//unpkg.com/pdfjs-dist@${pdfJS.version}/build/pdf.worker.min.js`;
            
          const doc = await pdfJS.getDocument({url: file, nativeImageDecoderSupport: 'none', disableFontFace: true}).promise
          
          const page = await doc.getPage(1) */

          /* page.getOperatorList().then(function(ops: any) {
            const fns = ops.fnArray,
                  args = ops.argsArray;

            let imgsFound = 0;
            args.forEach((arg, i) => {
                if (fns[i] !== pdfJS.OPS.paintImageXObject) { return; }

                imgsFound++;
              const images = [];
                const imgKey = arg[0];
                      const imgInfo = {
                          name: file.name + '-' + imgsFound + '.jpg',
                          url: '',
                      };
                images.push(imgInfo);

                page.objs.get(imgKey, img => {


                  const canvas = document.createElement('canvas');
                  canvas.width = img.width;
                  canvas.height = img.height;
                  const ctx = canvas.getContext('2d');
                  ctx!.putImageData(img.data, 0, 0);
                  const dataURL = canvas.toDataURL();
                  




                    imgInfo.url = img.src;
                });
            });
        }); */

        /*   return await page.getTextContent()
        }
    const that = this;
        async function getItems(file: any){
          const content = await getContent(file)
          var pdftext='';
          const items = content.items.map((item: any) => {
            pdftext = pdftext + item.str;
          })
          that.ocr_dedication = pdftext;

          apiClient
            .get(`medo/${that.id}/${pdftext}`)
            .then(({ data }) => {
              
            })
            .catch(function (error: any){
              
            });
        }
    } */

    /* getItems(URL.createObjectURL(file));
    async function getContent(file: any){
      
      const pdfJS = await import('pdfjs-dist/build/pdf');
			pdfJS.GlobalWorkerOptions.workerSrc =  `//unpkg.com/pdfjs-dist@${pdfJS.version}/build/pdf.worker.min.js`;
        
      const doc = await pdfJS.getDocument(file).promise
      const page = await doc.getPage(1)
      page.getOperatorList().then(function (ops: any) {
       
        for (var i=0; i < ops.fnArray.length; i++) {
             */
                /* page.getOperatorList().then(function (ops) {
                  for (var i=0; i < ops.fnArray.length; i++) {
                      if (ops.fnArray[i] == PDFJS.OPS.paintJpegXObject) {
                          window.objs.push(ops.argsArray[i][0])
                      }
                  }
              }) */
            
        /* }
    })
      return await page.getTextContent()
    }
    
    async function getItems(file: any){
      const content = await getContent(file)
      var pdftext='';
      const items = content.items.map((item: any) => {
        pdftext = pdftext + item.str;
      })
      this.ocr_dedication = pdftext;
    } */








/*     const PDF_PATH = URL.createObjectURL(file);
const PAGE_NUMBER = 1;
const PAGE_SCALE = 1.5;
const SVG_NS = "http://www.w3.org/2000/svg"; */



/* pdfjsLib.GlobalWorkerOptions.workerSrc =
  "../../node_modules/pdfjs-dist/build/pdf.worker.js"; */

/* function buildSVG(viewport: any, textContent: any) {
  // Building SVG with size of the viewport (for simplicity)
  const svg = document.createElementNS(SVG_NS, "svg:svg");
  svg.setAttribute("width", viewport.width + "px");
  svg.setAttribute("height", viewport.height + "px");
  // items are transformed to have 1px font size
  svg.setAttribute("font-size", 1);

  // processing all items
  textContent.items.forEach(function (textItem: any) {
    // we have to take in account viewport transform, which includes scale,
    // rotation and Y-axis flip, and not forgetting to flip text.
    const tx = pdfjsLib.Util.transform(
      pdfjsLib.Util.transform(viewport.transform, textItem.transform),
      [1, 0, 0, -1, 0, 0]
    );
    const style = textContent.styles[textItem.fontName];
    // adding text element
    const text = document.createElementNS(SVG_NS, "svg:text");
    text.setAttribute("transform", "matrix(" + tx.join(" ") + ")");
    text.setAttribute("font-family", style.fontFamily);
    text.textContent = textItem.str;
    svg.append(text);
    });
    return svg;
  } */

  /* async function pageLoaded() {
    // Loading document and page text content
    const loadingTask = pdfjsLib.getDocument({ url: PDF_PATH });
    const pdfDocument = await loadingTask.promise;
    const page = await pdfDocument.getPage(PAGE_NUMBER);
    const viewport = page.getViewport({ scale: PAGE_SCALE });
    const textContent = await page.toDataURL();
    // building SVG and adding that to the DOM

    

    var pdftext='';
      const items = textContent.items.map((item: any) => {
        pdftext = pdftext + item.str;
      })
      

    // Release page resources.
    page.cleanup();
  }

  pageLoaded(); */

  
    
    

    {/* end */}
    
    this.fingerprint = generateId({
      name: this.name,
      size: this.size,
      mime: this.mime,
      lastModified: this.lastModified,
    });
  }
}

interface FileMeta {
  name?: string;
  mime?: string | null;
  size?: number | string;
  lastModified?: number;
  relativePath?: string;
}
function generateId({name, mime, size, relativePath, lastModified}: FileMeta) {
  let id = 'be';
  if (typeof name === 'string') {
    id += `-${encodeFilename(name.toLowerCase())}`;
  }

  if (mime) {
    id += `-${mime}`;
  }

  if (typeof relativePath === 'string') {
    id += `-${encodeFilename(relativePath.toLowerCase())}`;
  }

  if (size !== undefined) {
    id += `-${size}`;
  }
  if (lastModified !== undefined) {
    id += `-${lastModified}`;
  }

  id += `${getActiveWorkspaceId()}`;

  // add version number, so it can be incremented easily to allow uploading same file multiple times
  return `${id}-v1`;
}

function encodeCharacter(character: string) {
  return character.charCodeAt(0).toString(32);
}

function encodeFilename(name: string) {
  let suffix = '';
  return (
    name.replace(/[^A-Z0-9]/gi, character => {
      suffix += `-${encodeCharacter(character)}`;
      return '/';
    }) + suffix
  );
}
